/* global Swiper */

Wee.fn.make('index', {
	init: function() {
		var scope = this,
			$cardSlider = $('.card-slider'),
			$hero = $('ref:homepageHero');

		if ($cardSlider.length) {
			scope.$swiper = $('.swiper-homepage')[0];

			$.screen.map([
					{
						max: 2,
						callback: function() {
							scope.destroySwiper();

							scope.initSwiper(true);
						}
					},
					{
						min: 3,
						callback: function() {
							scope.destroySwiper();

							scope.initSwiper();
						}
					}
			]);
		}

		if ($('ref:weeTopAlert').length) {
			$hero.addClass('-withAlert');
		}
	},
	initSwiper: function(mobile) {
		var config = {
				spaceBetween: 10,
				nextButton: '.swiper-button-next',
				loop: true
			};

		if (mobile) {
			config.width = 300;
		}

		Swiper(this.$swiper, config);
	},
	destroySwiper: function() {
		if (this.$swiper.swiper) {
			this.$swiper.swiper.destroy();
		}
	}

});
